export default __webpack_public_path__ + "static/media/4. Post Visit Patient Reflection.e4d9ee04.wav";